import { render, staticRenderFns } from "./ChangeFees.vue?vue&type=template&id=5ee45d82&"
import script from "./ChangeFees.vue?vue&type=script&lang=js&"
export * from "./ChangeFees.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/live/admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5ee45d82')) {
      api.createRecord('5ee45d82', component.options)
    } else {
      api.reload('5ee45d82', component.options)
    }
    module.hot.accept("./ChangeFees.vue?vue&type=template&id=5ee45d82&", function () {
      api.rerender('5ee45d82', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/bespoke/reservationAdministration/ChangeFees.vue"
export default component.exports